import api from './api';
import logger from '../utils/logger';

class PaymentsService {
  /**
   * Fetch payments with filters
   * @param {object} filters - { status, q, limit, offset, userId }
   */
  async fetchPayments(filters = {}) {
    try {
      // Filter out undefined/null values before building query string
      const cleanFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== undefined && v !== null && v !== '')
      );
      const qs = new URLSearchParams(cleanFilters).toString();
      const url = `/payments/all${qs ? `?${qs}` : ''}`;
      const res = await api.get(url);
      return res;
    } catch (err) {
      logger.error('[PaymentsService] fetchPayments error:', err);
      throw err;
    }
  }

  async getPaymentByOrderId(orderId) {
    try {
      const res = await api.get(`/customer/payment/order/${encodeURIComponent(orderId)}`);
      return res;
    } catch (err) {
      logger.error('[PaymentsService] getPaymentByOrderId error:', err);
      throw err;
    }
  }

  async deletePayment(paymentId) {
    try {
      const res = await api.delete(`/payments/${encodeURIComponent(paymentId)}`);
      return res;
    } catch (err) {
      logger.error('[PaymentsService] deletePayment error:', err);
      throw err;
    }
  }
}

export default new PaymentsService();
